import React from 'react';
import { withScriptjs, withGoogleMap, GoogleMap, Marker, InfoWindow } from 'react-google-maps';
import marker from '../static/images/map_pointer.png';

const styleMap = [
  {
    featureType: 'administrative',
    elementType: 'labels.text.fill',
    stylers: [
      {
        color: '#444444',
      },
    ],
  },
  {
    featureType: 'landscape',
    elementType: 'all',
    stylers: [
      {
        color: '#f2f2f2',
      },
    ],
  },

  {
    featureType: 'road',
    elementType: 'all',
    stylers: [
      {
        saturation: -100,
      },
      {
        lightness: 45,
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'all',
    stylers: [
      {
        visibility: 'simplified',
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'transit',
    elementType: 'all',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'water',
    elementType: 'all',
    stylers: [
      {
        color: '#46bcec',
      },
      {
        visibility: 'on',
      },
    ],
  },
];

const MyMapComponent = withScriptjs(
  withGoogleMap(props => (
    <GoogleMap
      defaultZoom={14}
      defaultCenter={{ lat: 50.10309, lng: 18.228924 }}
      defaultOptions={{ disableDefaultUI: true, styles: styleMap }}
    >
      {props.isMarkerShown && (
        <Marker
          icon={{ url: marker, scaledSize: { height: 50, width: 40 } }}
          title="LUK & LUK Auto Serwis s.c."
          position={{ lat: 50.10309, lng: 18.228924 }}
        >
          <InfoWindow>
            <div>
              <h4>{props.title}</h4>
              <p dangerouslySetInnerHTML={{ __html: props.address }} />
            </div>
          </InfoWindow>
        </Marker>
      )}
    </GoogleMap>
  )),
);

export default MyMapComponent;



// WEBPACK FOOTER //
// ./src/components/Map.js